import type {FC} from 'react';
import {memo, useEffect, useState} from 'react';

import ModalWindowContainer from '@src/modules/ModalWindowContainer/ModalWindowContainer';

import AnimateShow from '../AnimateShow/AnimateShow';
import CustomConfetti from '../CustomConfetti/CustomConfetti';
import Modal from '../Modal/Modal';

interface Props {
  children: any;
  className?: string;
  classNameBody?: string;
  classNameCloseBut?: string;
  classNameHeader?: string;
  closeModalHandler: () => void;
  header?: string;
  hideCloseBut?: boolean;
  isBody?: boolean;
  isCongratAnim?: boolean;
  showModal: boolean;
}

const ModalAnimateWin: FC<Props> = ({
  children,
  className = '',
  classNameBody = '',
  classNameCloseBut = '',
  classNameHeader = '',
  closeModalHandler,
  header = '',
  hideCloseBut,
  isBody = false,
  isCongratAnim = false,
  showModal,
}) => {
  const [isOpen, togOpen] = useState(showModal);
  const [isAnimate, togAnimate] = useState(false);

  const closeModal = () => {
    closeModalHandler();
  };

  const handleCallBackEndAnim = () => {
    togOpen(false);
  };

  useEffect(() => {
    if (showModal) {
      togOpen(showModal);
      togAnimate(true);
    } else {
      togAnimate(false);
    }
  }, [showModal]);

  return (
    <>
      {isOpen ? (
        <Modal>
          {isCongratAnim ? <CustomConfetti /> : null}
          <AnimateShow
            callBackHide={handleCallBackEndAnim}
            isAnimateShow={isAnimate}
          >
            <ModalWindowContainer
              className={className}
              classNameCloseBut={classNameCloseBut}
              closeModalWindowContainer={hideCloseBut ? undefined : closeModal}
            >
              {isBody ? (
                <>
                  <div className={classNameHeader}>
                    <h2>{header}</h2>
                  </div>
                  <div className={classNameBody}>{children}</div>
                </>
              ) : (
                children
              )}
            </ModalWindowContainer>
          </AnimateShow>
        </Modal>
      ) : (
        ''
      )}
    </>
  );
};

export default memo(ModalAnimateWin);
